<template>
  <div class="uploadImgDiv">
    <div :class="{'disabledUpload' : disabled,'hasResult':result}" class="uploadBtn">
      <el-upload
        v-loading="loading"
        action="/zzgagent-pay-customer/merchant-stock/upload-pic"
        :show-file-list="false"
        accept="image/*"
        :auto-upload="false"
        list-type="picture-card"
        :data="otherData"
        :on-change="changeUploadImg"
        :disabled="disabled">
        <div class="resultDiv" v-if="resultShow">
          <img :src="resultShow" alt=""/>
          <div class="hoverShowDiv">
            <div class="editDiv">
              <span v-if="showBigger" @click.stop="showBigImg" ><i class="el-icon-zoom-in"></i></span>
              <span v-if="download" @click.stop="downLoadImg" ><i class="el-icon-download"></i></span>
            </div>
            <span class="reUpload" v-if="!disabled">点击重新上传</span>
            <span class="reUpload" v-else>不可编辑</span>
          </div>
        </div>
        <i :class="iconType" v-else></i>
      </el-upload>
    </div>
    <p v-if="label !== ''" :class="['label', labelCenter ? 'labelCenter' : '']">
      <font color="red" v-if="required">*</font>{{ label }}
    </p>
    <p class="desc">{{ desc }}</p>
    <!--  图片放大弹窗    -->
    <el-dialog title="查看图片详情" :visible.sync="dialogBigImgVisible" width="800px" append-to-body>
      <img :src="resultShow" alt="" class="bigImg">
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { singleTransPic, uploadPic } from '@/api/global'
export default {
  name: 'UploadImgEle',
  props: {
    // 上传的其他数据
    otherData: {
      type: Object,
      default: function () {
        return {
          picType: 'auxiliaryInfo'
        }
      }
    },
    // 是否可编辑
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: '',
      required: true
    },
    valueName: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请上传图片'
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    },
    // label是否居中
    labelCenter: {
      type: Boolean,
      default: true
    },
    // 文件大小上限
    picMaxSize: {
      type: Number,
      default: 1024 * 3
    },
    // 是否可放大
    showBigger: {
      type: Boolean,
      default: true
    },
    // 是否可下载
    download: {
      type: Boolean,
      default: false
    },
    // 图标类名
    iconType: {
      type: String,
      default: 'el-icon-plus'
    },
    // label下的描述内容
    desc: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      resultShow: '', // 显示的url
      result: '', // 存储的url
      dialogBigImgVisible: false
    }
  },
  watch: {
    value (val, oldVal) {
      if (!val) {
        // 删除之后去除展示路径
        this.resultShow = ''
        this.result = ''
        return
      }
      // 如果是重新上传，value值和result一致，说明不需要重新上传
      if (val !== this.result) {
        // 在只读的情况下，直接传带http的路径
        if (this.value.indexOf('http://') >= 0) {
          this.resultShow = val
        } else {
          const param = qs.stringify({ path: val })
          console.log(param)
          singleTransPic(param).then(response => {
            if (response.error_code === '0') {
              this.resultShow = response.data.show_path
              this.result = val
            }
          })
        }
      }
    }
  },
  mounted () {
    if (this.value && this.resultShow === '') {
      // 在只读的情况下，直接传带http的路径
      const that = this
      if (this.value.indexOf('http://') >= 0) {
        this.resultShow = this.value
      } else {
        const param = qs.stringify({ path: that.value })
        singleTransPic(param).then(response => {
          if (response.error_code === '0') {
            this.resultShow = response.data.show_path
          }
        })
      }
    }
  },
  methods: {
    // 上传图片
    async changeUploadImg (file) {
      if (file.raw.size > 1024 * 1024 * 3) {
        this.$message({
          showClose: true,
          message: '图片大小不能超过3M',
          type: 'error'
        })
      } else {
        this.loading = true
        await this.upload(file)
      }
    },
    upload (file) {
      var that = this
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.readAsDataURL(file.raw)
        reader.onload = function (e) {
          var file = this.result // 此处的this.result是文件流而不是内部参数
          file = file.split('base64,')
          var data = {
            base64pic: file[1],
            picType: 'auxiliaryInfo'
          }
          data = qs.stringify(data)
          uploadPic(data).then(data => {
            that.loading = false
            if (data.error_code === '0') {
              resolve()
              that.$message({
                message: data.error_msg,
                type: 'success'
              })
              that.resultShow = data.showPath
              that.result = data.path
              console.log(that.result)
              var result = Object.assign(data, {
                valueName: that.valueName
              })
              that.emitResult(result)
            } else {
              resolve(false)
              that.$message({
                message: data.error_msg,
                type: 'error'
              })
              that.emitResult(data)
            }
          }).catch((e) => {
            const that = this
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            reject(e)
            that.emitResult(data)
          })
        }
      }).catch(() => {
      })
    },
    // 图片放大
    showBigImg () {
      this.dialogBigImgVisible = true
    },
    // 下载图片，仍然有跨域问题
    downLoadImg () {
      var canvas = document.createElement('canvas')
      var img = document.createElement('img')
      img.onload = function (e) {
        canvas.width = img.width
        canvas.height = img.height
        var context = canvas.getContext('2d')
        context.drawImage(img, 0, 0, img.width, img.height)
        canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height)
        canvas.toBlob((blob) => {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'aaa'
          link.click()
        }, 'image/png')
      }
      img.setAttribute('crossOrigin', 'Anonymous')
      img.src = this.resultShow
    },
    emitResult (result) {
      this.$emit('upload', result)
    }
  }
}
</script>

<style scoped>
  .uploadImgDiv{
    display: inline-block;
  }
  .uploadBtn{
    width: 120px;
    margin: 0 auto;
  }
  .uploadBtn img{
    width: 100%;
  }
  .hoverShowDiv{
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0,0,0,.5);
    transition: opacity .3s;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .hoverShowDiv .editDiv,.hoverShowDiv .reUpload{
    display: none;
    cursor: pointer;
  }
  .hoverShowDiv i{
    color: #fff;
    font-size: 25px;
  }
  .resultDiv:hover{
    box-shadow: 0 0 8px 0 rgba(232,237,250,.6),0 2px 4px 0 rgba(232,237,250,.5);
  }
  .resultDiv:hover .hoverShowDiv{
    /*.resultDiv .hoverShowDiv{*/
    opacity: 0.8;
  }
  .resultDiv:hover .hoverShowDiv .editDiv{
    /*.resultDiv .hoverShowDiv .editDiv{*/
    height: 89px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .resultDiv:hover .hoverShowDiv .reUpload{
    /*.resultDiv .hoverShowDiv button.reUpload{*/
    display: inline-block;
  }
  .uploadBtn .resultDiv{
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    justify-content: center;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    overflow: hidden;
    border-radius: 6px;
  }
  img.bigImg {
    width: 100%;
    display: block;
  }
  .reUpload{
    width: 120px;
    height: 27px;
    line-height: 25px;
    border: none;
    background: rgba(0,0,0,0.8);
    border-radius: 6px;
    font-size: 13px;
    color: #fff;
    outline: none;
  }
  .label{
    margin: 0;
  }
  .labelCenter{
    text-align: center;
  }
  .desc{
    font-size: 12px;
    color: #666;
    line-height: 14px;
    margin: 0;
    text-align: center;
  }
</style>
<style>
  .uploadBtn .el-upload--picture-card{
    width: 120px;
    height: 120px;
    line-height: 120px;
    border: 2px dashed #c0ccda;
  }
  .uploadBtn.disabledUpload .el-upload--picture-card:hover{
    cursor: no-drop;
  }
</style>
